import * as React from 'react'
import { Button } from 'primereact'
import Icon from 'app/shared/components/Icon'
import Navigation from './Navigation'
import useBasePage from '../hooks/base-page.hook'
import { useLazySelectComUrl0102Query } from 'app/core/services/com/com.service'
import { showAlert, showConfirm } from '../utils/util'
import { convertToHtml } from '../utils/comUtil'

interface HeaderProps {
    prev?: Boolean
    menu?: Boolean
    share?: Boolean
    product?: Boolean
    productAlert?: Boolean
    chatbot?: Boolean
    chatBotUrl?: string
    title?: React.ReactNode
    className?: string
    onPrev?: () => void
    onShare?: (open: boolean) => void
}

const Header: React.FC<HeaderProps> = ({
    prev,
    onPrev,
    menu,
    share,
    chatbot,
    chatBotUrl,
    onShare,
    product,
    productAlert,
    title,
    className,
}) => {
    const router = useBasePage()

    const [navigation, setNavigation] = React.useState(false)
    const headerRef = React.useRef<HTMLDivElement>(null)

    React.useEffect(() => {
        const topPadding = () => {
            const root = document.getElementById('root')
            if (!headerRef.current || !root) return
            let headerHeight = headerRef.current.getBoundingClientRect().height
            root.style.paddingTop = `${headerHeight || 56}px`
            root.style.setProperty(
                '--body-padding-top',
                `${headerHeight || 56}px`
            )
        }
        const timeout = setTimeout(() => {
            topPadding()
        }, 80)
        window.addEventListener('resize', topPadding)
        return () => {
            clearTimeout(timeout)
            window.removeEventListener('resize', topPadding)
        }
    }, [])
    return (
        <>
            <header ref={headerRef} id="header" className={className}>
                {prev && (
                    <Button className="btn-prev" onClick={onPrev}>
                        <Icon name="arrow-left" text="뒤로가기"></Icon>
                    </Button>
                )}
                <h1>{title}</h1>

                {share && (
                    <Button
                        className="btn-share"
                        onClick={() => {
                            onShare(true)
                        }}
                    >
                        <Icon name="share" text="공유하기"></Icon>
                    </Button>
                )}

                {chatbot && chatBotUrl && (
                    <Button
                        className="btn-chatbot"
                        onClick={() => {
                            window.open(convertToHtml(chatBotUrl), '_blank')
                        }}
                    >
                        <Icon name="chatbot2" text="챗봇"></Icon>
                    </Button>
                )}

                {product && (
                    <Button
                        className="btn-product"
                        onClick={() => {
                            if (product) {
                                // productAlert 으로 사용 가능
                                showConfirm({
                                    msg: '상품 가입을 완료하지 못했어요.<br>다음에 이어서 가입하시겠어요?',
                                    onConfirm: () => router.goProductMall(true),
                                })
                            } else {
                                router.goProductMall(true)
                            }
                        }}
                    >
                        <Icon name="product" text="상품몰 바로가기"></Icon>
                    </Button>
                )}

                {menu && (
                    <Button
                        className="btn-menu"
                        onClick={() => setNavigation(true)}
                    >
                        <Icon name="menu" text="전체메뉴"></Icon>
                    </Button>
                )}
            </header>
            <Navigation
                open={navigation}
                onClose={() => setNavigation(false)}
            />
        </>
    )
}

export default Header
